import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { NotificationDialogComponent } from './features/notifications/notification-dialog/notification-dialog.component';
import { ResolveJobIssueDialogComponent } from './features/notifications/components/resolve-job-issue-dialog/resolve-job-issue-dialog.component';
import { StoreModule } from '@ngrx/store';
import { rolesReducer } from './state/roles/roles.reducer';
import { EffectsModule } from '@ngrx/effects';
import { RolesEffects } from './state/roles/roles.effects';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [AppComponent, NotificationDialogComponent, ResolveJobIssueDialogComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    StoreModule.forRoot({ roles: rolesReducer }, {}),
    EffectsModule.forRoot([RolesEffects]),
    AngularEditorModule,
    DragDropModule
  ],
  providers: [
    // { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
